import * as React from 'react'
import * as PropTypes from 'prop-types'
import { PortalWithState } from 'react-portal'

import { Theme } from '../../theme'

import { Touchable } from '../touchable'

function isNodeInRoot(node: (Node & ParentNode) | null, root: Node) {
  while (node) {
    if (node === root) {
      return true
    }
    node = node.parentNode // eslint-disable-line no-param-reassign
  }
  return false
}

interface IOverlayProps {
  children: (props: { ref: React.RefObject<{}> }) => React.ReactNode
  handleClose: () => void
}

export class Overlay extends React.Component<IOverlayProps> {
  static propTypes = {
    children: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
  }

  constructor(props: IOverlayProps) {
    super(props)

    this.childRef = React.createRef()
  }

  handleClose = (e: React.SyntheticEvent<Element, Event>) => {
    this.childRef.current &&
      !isNodeInRoot(e.target as Node & ParentNode, this.childRef.current as Node & ParentNode) &&
      this.props.handleClose()
  }

  childRef: React.RefObject<{}>

  render() {
    const { children } = this.props

    return (
      <PortalWithState closeOnEsc defaultOpen onClose={this.handleClose as any}>
        {() => (
          <div>
            <Theme>
              {theme => (
                <Touchable
                  onClick={this.handleClose}
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: theme.settings.zLayers.portal - 1,
                    width: '100vw',
                    backgroundColor: 'rgba(44, 55, 61, 0.2)',
                    height: '100vh',
                  }}
                >
                  {children({ ref: this.childRef })}
                </Touchable>
              )}
            </Theme>
          </div>
        )}
      </PortalWithState>
    )
  }
}
